export type AuthUser = {
  id: number;
  email: string | null;
  phone: string | null;
  role: string | null;
  firstName: string | null;
  lastName: string | null;
};

export type AuthResponse = {
  authenticated: boolean;
  user: AuthUser | null;
};

export async function fetchCurrentUser() {
  const response = await fetch("/api/auth/me", {
    credentials: "include",
    headers: {
      Accept: "application/json"
    }
  });

  if (!response.ok) {
    throw new Error(`Unable to fetch current user: ${response.status}`);
  }

  return (await response.json()) as AuthResponse;
}

export function roleHomePath(role: string | null | undefined) {
  if (role === "ADMIN") {
    return "/admin";
  }
  if (role === "SALES") {
    return "/sales";
  }
  return "/shop";
}
